import { render, staticRenderFns } from "./votingLinks.vue?vue&type=template&id=25b2349e&scoped=true&"
import script from "./votingLinks.vue?vue&type=script&lang=js&"
export * from "./votingLinks.vue?vue&type=script&lang=js&"
import style0 from "./votingLinks.vue?vue&type=style&index=0&id=25b2349e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b2349e",
  null
  
)

export default component.exports